import React from 'react';
import { FancyButton } from './FancyButton';

interface NormalButtonProps {
  disabled?: boolean;
  fontSize?: number;
  onClick: () => void;
}

export const NormalButton: React.FC<NormalButtonProps> = props => {
  return (
    <FancyButton {...props} color="#4d3906" background="#dbcca7">
      {props.children}
    </FancyButton>
  );
};
